// extracted by mini-css-extract-plugin
export default {"SignupForm":"styles_SignupForm__xxE5z","fieldsWrapper":"styles_fieldsWrapper__91woP"};